export default __webpack_public_path__ + "static/media/chatbot_bare.5838a06d.svg";